module.exports = __webpack_public_path__ + "img/step6-c.cb27f1d8.png";